module.exports = __webpack_public_path__ + "img/description-2.324e92f9.png";